import spanish from './spanish';

const currentLanguage = 'es';//localStorage.getItem('es');

const language = {
    'es': spanish
}

export default language[currentLanguage];